import * as React from "react";
const SvgComponent = ({ strokeColor = "#90EE90", ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    width="100%"
    height="100%"
    style={{
      enableBackground: "new 0 0 130 110",
    }}
    viewBox="6.99 9.2 119.82 86.4"
    {...props}
  >
    <style>
      {`.st1{display:inline}.st2,.st3{fill:none;stroke-miterlimit:10}.st2{stroke:#000;stroke-width:.3}.st3{stroke:#231f20}.st4{fill:#231f20}.st5{fill:none;stroke:${strokeColor};stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}`}
    </style>
    <g id="Layer_2_00000156563928147291571060000016873250913498868405_">
      <path
        d="M24.4 34.3s-4.7.2-7.3 1.8c-1.5.9-.6 2.2-.9 2.6-.3.4 0 1.2 1.9 1.9M109.6 34.3s4.7.2 7.3 1.8c1.5.9.6 2.2.9 2.6.3.4 0 1.2-1.9 1.9M18.5 86.3c1.4.1 11.3.5 13.5.5.1 0 5.8.9 7.9.9 2.2 0 1.9-.7 2.9-.8 1-.1 4.4.3 4.7-.3.5-1.1.7-1.2.7-1.2H85.4s.2.1.7 1.2c.3.6 3.7.2 4.7.3 1 .1.8.8 2.9.8 2.2 0 7.8-.9 7.9-.9 2.1 0 11.9-.4 13.6-.5"
        className="st5"
      />
      <path
        d="M115.2 86.3c.5.4.8.5.8.5s1.4 0 1.9-.1c.1 0 .2-.1.4-.2.5-.5 1.1-2.2 1.8-7.1v-.1c2.8-16.1-1.3-26.9-1.5-27.4v-.1c-.3-.7-1.6-5.2-2.3-8.1v-.1c-.2-2.4-.4-3.7-1.3-4.4-.1 0-.1-.1-.2-.1-.2-.7-1.7-3.1-5.2-4.9V34c-1.1-4.3-6-12.5-7.1-13.8-2.1-2.2-4.3-2.5-4.3-2.5s-1.5-1.1-3.2-1.4c-2.5-.3-5-.6-7.5-.8-2.2-.2-4.4-.4-6.6-.5-2.1 0-3.9-.1-5.7-.1H60.7c-1.6 0-3.3.1-4.9.1-2 .1-4 .2-6.1.3-2.4.2-4.7.4-7.1.6-1.2.1-2.5.3-3.7.4-1.7.3-3.2 1.4-3.2 1.4s-2.2.3-4.3 2.5c-1.2 1.3-6.2 9.8-7.2 14-.2.1-.3.2-.5.3h0c-3.1 1.8-4.5 4-4.7 4.6-.1 0-.1.1-.2.1-.9.7-1.1 2-1.3 4.4v.1c-.8 2.9-2 7.4-2.3 8.1v.1c-.3.4-4.3 11.3-1.5 27.4v.1c.7 5 1.3 6.6 1.8 7.1.1.2.3.2.4.2.5.1 1.9.1 1.9.1s.3-.1.7-.5"
        className="st5"
      />
      <path
        d="M27.2 39.2c-.2.3-.3 1.9-.3 3v.9s-2.6.3-5.3-.2c-2.5-1-1.9-3.6-1.9-3.6h1.6c1.5-.1 4-.1 5.9-.1zM44.9 44.1c-3.3.2-13.8-.5-16-.5.1-1.4.1-2.4.1-3.1 0-1.1-.1-1.7-.3-1.9 1.7.1 3.2.2 3.6.2 1 .2 3.2.9 7.1 3.1.7.3 1.4.7 2 1 1.4.6 2.6 1 3.5 1.2z"
        className="st5"
      />
      <path
        d="M48.1 45.4c-.1.1-2.3 2.2-3.4 2.3-1.1 0-24.3-.6-25.3-.5-.9.1-1.5.6-1.5.7-.1-.8-.1-2.9-.2-4.1v-.1c.2-2.6.4-3.9 1.4-4.5.1-.1.2-.1.3-.1 1.3-.7 1.4-.7 2.7-.7.8 0 4 .1 6.6.2 1.7.1 3.2.2 3.6.2 1 .2 3.2.9 7.1 3.1.1 0 .2.1.2.1 1.8.9 3.9 1.7 5.2 2.1.5.1.9.2 1.1.2 0 0 1.4.1 1.8.2.4.1.5.8.4.9zM106.5 39.2c.2.3.3 1.9.3 3v.9s2.6.3 5.3-.2c2.5-1 1.9-3.6 1.9-3.6h-1.6c-1.5-.1-4-.1-5.9-.1zM88.8 44.1c3.3.2 13.8-.5 16-.5-.1-1.4-.1-2.4-.1-3.1 0-1.1.1-1.7.3-1.9-1.7.1-3.2.2-3.6.2-1 .2-3.2.9-7.1 3.1-.7.3-1.4.7-2 1-1.4.6-2.6 1-3.5 1.2z"
        className="st5"
      />
      <path
        d="M85.6 45.4c.1.1 2.3 2.2 3.4 2.3 1.1 0 24.3-.6 25.3-.5.9.1 1.5.6 1.5.7.1-.8.1-2.9.2-4.1v-.1c-.2-2.6-.4-3.9-1.4-4.5-.1-.1-.2-.1-.3-.1-1.3-.7-1.4-.7-2.7-.7-.8 0-4 .1-6.6.2-1.7.1-3.2.2-3.6.2-1 .2-3.2.9-7.1 3.1-.1 0-.2.1-.2.1-1.8.9-3.9 1.7-5.2 2.1-.5.1-.9.2-1.1.2 0 0-1.4.1-1.8.2-.4.1-.5.8-.4.9z"
        className="st5"
      />
      <path
        d="M27.7 47.3s-.1.8-.1 1.9c0 1.1 0 2.6.4 3.9 1.5 4.6 6.5 6.7 8 7s30.9.3 30.9.3 7.8 0 15.6-.1c7.3 0 14.6-.1 15.3-.3 1.5-.3 6.5-2.4 8-7 .6-2.7.3-5.8.3-5.8M103.6 34.6l-24.2-.1H52.8h0-22.6s3.5-12.9 5.5-14.5c.4-.1 1-.2 1.9-.3 4.2-.5 13.2-.7 20.2-.9 2.2 0 4.2-.1 5.8-.1H68.9c1.4 0 3.3 0 5.5.1 6.2.1 14.8.4 19.9.7 1.8.1 3.2.3 3.9.5.1.1.3.3.4.5 1.2 1.7 2.9 6.7 4 10.2.6 2.3 1 3.9 1 3.9zM12.9 70.3s-.9 16.8 0 22.6c.3 2.3 4.2 2.2 6.6 2.2s6.5 0 7.3-1.2c.7-1.2 1.4-7.2 1.4-7.2M120.9 70.3s.9 16.8 0 22.6c-.3 2.3-4.2 2.2-6.6 2.2s-6.5 0-7.3-1.2-1.4-7.2-1.4-7.2M48.1 45.4h37.5"
        className="st5"
      />
      <path
        d="M118.3 51.7s2.1 8.7-7.6 9.9c-7.9 1-34.5 1.3-43.7 1.4-7.4-.1-35.8-.3-44.2-1.4-9.6-1.3-7.5-9.9-7.5-9.9"
        className="st5"
      />
    </g>
  </svg>
);
export default SvgComponent;
